import { ChangeEvent } from 'react';
import { FormControl } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import GenericFormField from 'components/forms/genericFormField/GenericFormField';
import { FieldRendererProps } from 'components/forms/genericFormField/GenericFormField.types';
import {
  ColorField as ColorFieldName,
  toSwatchValue,
} from './ColorSettings.schema';
import {
  ColorFieldRowStyled,
  ColorHashStyled,
  ColorInputStyled,
  ColorSwatchStyled,
} from './ColorSettings.styles';

const ColorField = ({
  label,
  name,
}: {
  label: string;
  name: ColorFieldName;
}) => {
  const { setValue } = useFormContext();

  const handleSwatchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(name, event.target.value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  const fieldRenderer = ({
    field: { value, ref, onChange, onBlur },
  }: FieldRendererProps) => (
    <ColorFieldRowStyled>
      <ColorInputStyled data-testid={`${name}-control`}>
        <ColorHashStyled aria-hidden="true">#</ColorHashStyled>
        <FormControl
          data-testid={name}
          id={name}
          inputRef={ref}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
        />
      </ColorInputStyled>
      <ColorSwatchStyled
        aria-label={label}
        data-testid={`${name}-swatch`}
        onChange={handleSwatchChange}
        type="color"
        value={toSwatchValue(value)}
      />
    </ColorFieldRowStyled>
  );

  return (
    <GenericFormField
      colSmInput={7}
      colSmLabel={5}
      fieldRenderer={fieldRenderer}
      label={label}
      name={name}
    />
  );
};

export default ColorField;
